import { state } from 'cerebral'
import { find, isEmpty, propEq } from 'ramda'

export const current = (get) => {
  const resortId = get(state`account.organization._id`)
  const analyticsList = get(state`analyticsLive.list.data`) || []

  return find(propEq(resortId, 'resort'), analyticsList) || {}
}

export const metrics = (get) => {
  const currentResortMetrics = get(state`analyticsLive.current`)
  const flagInactiveAfterDays = get(state`account.organization.flagInactiveAfterDays`) || 7

  const { metrics: { activeResidents, trackableActivities } = {} } = currentResortMetrics

  if (!activeResidents && !trackableActivities) {
    return []
  }

  const result = []

  if (activeResidents) {
    const {
      //
      total,
      withAttendance,
      withoutAttendance,
      participationRate = {},
      window: { days: numberOfDays = flagInactiveAfterDays } = {},
    } = activeResidents

    const totalCount = total?.count || 0
    const attendanceCount = withAttendance?.count || 0
    const numberOfInactive = withoutAttendance?.count ?? 0
    const isNumberOfInactivePositive = numberOfInactive > 0

    const rate = isEmpty(participationRate) ? null : Math.round(participationRate?.percent?.toFixed(1))

    result.push(
      {
        id: 'participation-metric',
        label: `${numberOfDays}-Day Participation Rate`,
        value: rate != null ? `${rate}%` : '—',
        ...(participationRate?.percentDelta != null && { delta: Number(participationRate.percentDelta.toFixed(2)) }),
        detail:
          totalCount > 0
            ? `${attendanceCount} of ${totalCount} active residents attended at least one activity in the past ${numberOfDays} days.`
            : 'No data available yet.',
      },
      {
        id: 'inactive-residents',
        label: `${numberOfDays}-Day Inactive Residents`,
        value: String(numberOfInactive),
        status: isNumberOfInactivePositive ? 'danger' : 'neutral',
        detail: isNumberOfInactivePositive
          ? `${numberOfInactive} active residents have had no logged attendance or 1:1 interaction for ${numberOfDays} or more consecutive days.`
          : `All residents active within ${numberOfDays} days.`,
        action: isNumberOfInactivePositive
          ? {
              sequence: 'profiles.setInactiveResidents',
              label: 'View inactive',
            }
          : {},
      }
    )
  }

  if (trackableActivities && !isEmpty(trackableActivities)) {
    const trackedCount = trackableActivities.tracked?.count ?? 0
    const trackableCount = trackableActivities.total?.count ?? 0
    const untrackedPercent = trackableCount ? (trackedCount / trackableCount) * 100 : 0

    result.push({
      id: 'trackable-activities-7d',
      label: '7-Day Trackable Activities',
      value: `${trackedCount} of ${trackableCount}`,
      status: untrackedPercent < 80 ? 'danger' : 'success',
      detail: `${trackedCount} of ${trackableCount} trackable activities have attendance recorded over the last 7 days.`,
      action: {
        sequence: 'eventInstances.setAttendance7d',
        label: 'View untracked',
      },
    })
  }

  result.push({
    id: 'engagement-health-score',
    label: 'Engagement Health Score',
    value: '—',
  })

  return result
}
